export enum EnumUserEdit {
  CONTACT = 0,
  ADDRESS = 1,
  USERINFO = 2,
}
